import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import { DASHBOARD_TYPE } from '@utils/constants';
import { changeMode } from '@store/trends/actions';
import { MODE_AI_ALERT_DIAGNOSTICS, MODE_TRENDS, MODE_ALERT_DIAGNOSTICS  } from '@store/trends/constants';
import { get as lodashGet } from 'lodash';
import * as types from './types';
import { updateState } from '../sharing/sagas';

function* afterRequest({ payload: savedData }) {
  const state: any = lodashGet(savedData, ['config', 'state'], null);

  if (!state) {
    return;
  }

  const dashboardType = state.selectedAiAlert
    ? DASHBOARD_TYPE.AI_ALERT_DIAGNOSTICS : DASHBOARD_TYPE.TRENDS;

  // sd-TODO: might need to enable for manual alerts saved dashboard
  // workaround as shared manual alerts page does not have a unique type identifier
  const selectedManualAlert = lodashGet(state, ['module:trends', 'alerts', 'selectedEvent'], null);

  // eslint-disable-next-line no-useless-catch
  try {
    yield call(updateState, state);

    // TODO: the below section can also go into updateState
    if (dashboardType === DASHBOARD_TYPE.AI_ALERT_DIAGNOSTICS) {
      yield put(changeMode(MODE_AI_ALERT_DIAGNOSTICS));
    } else {
      yield put(changeMode(selectedManualAlert ? MODE_ALERT_DIAGNOSTICS : MODE_TRENDS));
    }
  } catch (error) {
    throw error;
  }
}

function* watchSetSaving() {
  yield takeLatest([types.SET_SAVING], afterRequest);
}

export default [watchSetSaving];
